/**
 * 官网 HTTP 请求封装
 * 统一处理后端 { code, data, message } 响应格式，成功时直接返回 data
 * 门户 IP 拉黑 403：派发事件标记访问受限，不清 visitorId、不跳登录
 */
import axios from 'axios'

const request = axios.create({
  baseURL: '/',
  timeout: 30000
})

export const PORTAL_ACCESS_RESTRICTED_EVENT = 'zg-portal-access-restricted'
const ACCESS_RESTRICTED_MESSAGE = '访问受限'

function isPortalIpRestrictedMessage(message) {
  const text = String(message || '')
  return (
    /当前\s*IP\s*已被限制访问/.test(text) ||
    /接口请求过于频繁[，,].*IP.*自动限制/.test(text) ||
    /访问受限/.test(text)
  )
}

function notifyAccessRestricted(message) {
  const text = message || ACCESS_RESTRICTED_MESSAGE
  try {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent(PORTAL_ACCESS_RESTRICTED_EVENT, {
          detail: { message: ACCESS_RESTRICTED_MESSAGE }
        })
      )
    }
  } catch {
    /* ignore */
  }
  return text
}

function createRestrictedError(message) {
  notifyAccessRestricted(message)
  const err = new Error(ACCESS_RESTRICTED_MESSAGE)
  err.code = 403
  err.ipRestricted = true
  return err
}

function markRestrictedIfNeeded(error) {
  const status = error?.response?.status
  const data = error?.response?.data
  const message = data?.message || error?.message || ''
  if (isPortalIpRestrictedMessage(message)) {
    return createRestrictedError(message)
  }
  // nginx 直出 403（可能无 JSON）
  if (status === 403 || data?.code === 403 || data?.code === '403') {
    return createRestrictedError(message || ACCESS_RESTRICTED_MESSAGE)
  }
  return null
}

request.interceptors.response.use(
  (response) => {
    const res = response.data
    // 业务错误：code !== 0 时抛出异常，由调用方 catch 处理
    if (res?.code !== 0) {
      if (res?.code === 403 || res?.code === '403' || isPortalIpRestrictedMessage(res?.message)) {
        return Promise.reject(createRestrictedError(res?.message))
      }
      return Promise.reject(new Error(res?.message || '请求失败'))
    }
    return res.data
  },
  (error) => {
    const restricted = markRestrictedIfNeeded(error)
    if (restricted) {
      return Promise.reject(restricted)
    }
    const message = error?.response?.data?.message || error?.message || '网络错误'
    return Promise.reject(new Error(message))
  }
)

export default request
